import React, { useEffect, useState } from "react";
import { Container, ThinkingText } from "./__styles__/ThinkingIndicator";
import LoadingSpinner from "./LoadingSpinner";

/** Thinking phrases for initial planning (before tool calls start) */
export const BUILDER_THINKING_PHRASES = [
  "Sketching out fields...",
  "Drafting the blueprint...",
  "Planning the layout...",
  "Analyzing requirements...",
  "Designing the structure...",
];

/** Working phrases for between tool calls (actively modifying the form) */
export const BUILDER_WORKING_PHRASES = [
  "Adding the next field...",
  "Updating the form...",
  "Applying changes...",
  "Configuring settings...",
  "Building out the structure...",
  "Making adjustments...",
  "Wiring up inputs...",
  "Setting up options...",
];

/** Default generic thinking phrases */
export const DEFAULT_THINKING_PHRASES = ["Thinking..."];

export interface ThinkingIndicatorProps {
  phrases?: string[];
  intervalMs?: number;
}

const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({
  phrases = DEFAULT_THINKING_PHRASES,
  intervalMs = 3000,
}) => {
  const [currentIndex, setCurrentIndex] = useState(() =>
    Math.floor(Math.random() * phrases.length),
  );

  useEffect(() => {
    if (phrases.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % phrases.length);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [phrases.length, intervalMs]);

  return (
    <Container>
      <LoadingSpinner />
      <ThinkingText>{phrases[currentIndex]}</ThinkingText>
    </Container>
  );
};

export default ThinkingIndicator;
